import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import Modal from "../Components/Modal";
import CollapseCard from "../Components/CollapseCard";
import DestinationForm from "../Components/DestinationForm";
import DestinationList from "../Components/DestinationList";
import { deleteDestination, getALLDestinations, saveDestination } from "../Service/DestinationService";
import { useToast } from "../Components/toast/ToastProvider";

const DestinationPage = () => {
  const [destinationData, setDestinationData] = useState([]);
  const [destinationForm, setDestinationForm] = useState({ title: "" });
  const [showModal, setShowModal] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchDestination()
  }, [])

  const fetchDestination = async () => {
    try {
      const res = await getALLDestinations()
      setDestinationData(res.data);
    } catch (err) {
      alert(err.message || "Failed to fetch destinations")
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!destinationForm.title) return alert('Please fill the destinations name')

      const dupicateName = destinationData.some((item)=>item.id !== destinationForm.id && item.title.trim().toLowerCase() === destinationForm.title.trim().toLowerCase());
      if(dupicateName){
        toast("Destination Name already exist","ERROR");
        return;
      }
    try {
      const payload = destinationForm.id ? { id: destinationForm.id, title: destinationForm.title } :
        { title: destinationForm.title }
      await saveDestination(payload)
      toast(destinationForm.id ? 'Destinations update successfully' : 'Destinations added successfully', "SUCCESS")
      fetchDestination()
      handleCancel()
    } catch (err) {
      toast(err.message || 'Failed to save destinations', "ERROR")
    }
  };

  const handleEdit = (item) => {
    setDestinationForm({ id: item.id, title: item.title });
    setShowModal(true);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setDestinationForm((prev) => ({ ...prev, [name]: value }));
  };


  // const handleDelete = async (index) => {
  //   if (!window.confirm("Are you sure you want to delete this destination?")) return
  //   try {
  //     await deleteDestination(destinationData[index].id)
  //     toast('destinations deleted successfully', "SUCCESS")
  //     fetchDestination()
  //   } catch (err) {
  //     alert(err.message || "Failed to delete source", "ERROR")
  //   }
  // };

  const handleCancel = () => {
    setDestinationForm({ title: "" });
    setShowModal(false);
  };

  return (
    <Main>
      <PageContainer
        titlePage="Destination"
        buttonText={"ADD"}
        onButtonClick={() => {
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={destinationForm.id ? "Edit Destination" : "Add Destination"}
        >
          <DestinationForm
            handleChange={handleChange}
            destinationForm={destinationForm}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        <CollapseCard title='Destination'>
          <DestinationList
            destinationData={destinationData}
            handleEdit={handleEdit}
            // handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default DestinationPage;
